import React     from 'react';
import PropTypes from 'prop-types';

function CamsSeoFooter({text}) {
	if (!text) {
		return null;
	}

	return <div className={'cams__seo-footer'}>
			    <div className='cams__seo-footer__text' dangerouslySetInnerHTML={{__html: text}}></div>
		   </div>;	
}

CamsSeoFooter.propTypes = {
	text: PropTypes.string,
};

CamsSeoFooter.defaultProps = {
	text: '',
};

export default CamsSeoFooter;